module.exports = __webpack_public_path__ + "img/dp.0fd4a9e0.png";